export default __webpack_public_path__ + "static/media/supply_chain.3a460ed7.png";